import { Injectable,EventEmitter  } from '@angular/core';
import { PrinterType } from './printertype.enum'
import {Store,Printer,ReplyMessage, DiningArea, Table} from './stores.interface'

declare var firebase: any

export enum DeliverType {
  Inside,
  TakeOut,
  Delivery,
  Mailing
}

@Injectable()
export class StoresService {
  static readonly STORES = 'stores'
  static readonly PRINTERS = 'printers'
  static readonly REPLYMESSAGES = 'replyMessages'
  static readonly TABLES = 'tables'
  static readonly DININGAREAS = 'diningAreas'
  static readonly CATEGORIES = 'categories'
  static readonly PRODUCTS = 'products'
  static readonly PRODUCTSETS = 'productSets'

  currentBrandId:string
  currentPage:number
  storeUpdated = new EventEmitter()
  constructor() { }

  // stories
  getBrandStores() {
    return firebase.firestore().collection('stores').where('brandId','==',this.currentBrandId).get()
  }

  brandStores() {
    return firebase.firestore().collection('stores').where('brandId','==',this.currentBrandId)

  }

  getStore(storeId:string) {
    return firebase.firestore().collection('stores').doc(storeId).get()
  }

  uploadStoreImage(file:File) {
    let metadata = {
        contentType: file.type
    }

    let array = file.type.split('/')
    let type = ''
    if (array.length > 1) {
        type = array[1]
    }
    let ref = firebase.storage().ref().child('storeImages/'+this.currentBrandId+Date.now()+'.'+type)
    return ref.put(file)
  }

  createStore(storeInfo:Store) {
    storeInfo.storeStaff = []
    storeInfo.storeAdmins = []
    storeInfo.categoryTree = []
    storeInfo.createdAt = Date.now()
    storeInfo.updatedAt = Date.now()
    // storeInfo.posCode = Math.random().toString(36).substring(8);
    let str = '';
    for(let i=0; i<8; i++){
      let rand = Math.floor( Math.random() * 62 );
      let charCode = rand+= rand>9? (rand<36?55:61) : 48
      str += String.fromCharCode( charCode );
    }
    storeInfo.posCode = str

    storeInfo.brandId = this.currentBrandId
    return firebase.firestore().collection('stores').add(storeInfo)
  }

  updateStore(storeId:string,storeInfo:any) {
    storeInfo.updatedAt = Date.now()

    return firebase.firestore().collection('stores').doc(storeId).update(storeInfo)
  }

  refreshPosCode(id:string):Promise<string> {
    let str = '';
    for(let i=0; i<8; i++){
      let rand = Math.floor( Math.random() * 62 );
      let charCode = rand+= rand>9? (rand<36?55:61) : 48
      str += String.fromCharCode( charCode );
    }

    return new Promise(
      (resolve, reject) => {
        this.updateStore(id,{posCode:str}).then(
          () => {
            resolve(str)
          }
        ).catch(
          err => {
            reject(err)
          }
        )
      })
  }

  getStoreCollection(storeId:string,node:string) {
    return firebase.firestore().collection(StoresService.STORES).doc(storeId).collection(node).get()
  }

  getStoreNodeDoc(storeId:string,node:string,id:string) {
    return firebase.firestore().collection(StoresService.STORES).doc(storeId).collection(node).doc(id).get()

  }

  createStoreNodeDoc(storeId:string,node:string,info:any) {
    info.createdAt = Date.now()
    info.updatedAt = Date.now()
    return firebase.firestore().collection(StoresService.STORES).doc(storeId).collection(node).add(info)
  }

  updateStoreNodeDoc(storeId:string,node:string,info:any) {
    let doc = Object.assign({},info)
    doc.updatedAt = Date.now()
    let id = doc.id
    delete doc.id
    return firebase.firestore().collection(StoresService.STORES).doc(storeId)
              .collection(node).doc(id).update(doc)
  }

  setStoreNodeDoc(storeId:string,node:string,info:any) {
    let doc = Object.assign({},info)
    doc.updatedAt = Date.now()
    let id = doc.id
    delete doc.id
    return firebase.firestore().collection(StoresService.STORES).doc(storeId)
              .collection(node).doc(id).set(doc)
  }

  deleteStoreNodeDoc(storeId:string,node:string,docId:string) {
    return firebase.firestore().collection(StoresService.STORES).doc(storeId).collection(node).doc(docId).delete()
  }

  getCategorySnapshot(storeId:string) {
    return firebase.firestore().collection(StoresService.STORES).doc(storeId).collection(StoresService.CATEGORIES)
  }

  increateCategorySN(storeId:string) {
    let ref = firebase.firestore().collection(StoresService.STORES).doc(storeId)
    return ref.get().then(
        doc => {
          let sn = doc.data().cateSN || 0
          sn = sn + 1
          return ref.update({cateSN:sn}).then(
            () => {return Promise.resolve(sn)}
          ).catch (
            err => {return Promise.resolve(err)}
          )
        }
      )
  }

  getStoreOrders(storeId: string, start: number, end: number) {
    return firebase.firestore().collection('brands')
            .doc(this.currentBrandId)
            .collection('orders')
            .where('storeId', '==', storeId)
            .where('createdAt', '>=', start)
            .where('createdAt', '<=', end)
            .orderBy('createdAt')
            .get()
  }

  getStoreInvoices(storeId: string, start: number, end: number) {

    return firebase.firestore().collection('stores')
            .doc(storeId)
            .collection('invoices')
            .where('createdAt', '>=', start)
            .where('createdAt', '<=', end)
            .orderBy('createdAt')
            .get()
  }
}



// WEBPACK FOOTER //
// ./src/app/services/stores.service.ts